<template>
  <div>
    <loading :active.sync="isLoading" background-color="#D0D0D0">
      <div class="loadingio-spinner-eclipse-y24d302hfm">
        <div class="ldio-f9ujl5oazv5">
          <div></div>
        </div>
      </div>
    </loading>

    <!-- <div class="PcDevice" v-if="NoMenuPage || ShowChatRoom">
      <div v-if="!NoShowCompo">
        <div class="floatChatIcon" @click="openChatbox">
          <img src="../../assets/images/customer-care.png" width="57px" class="mb-3" alt="" />
          <div class="unreadFrame" v-if="notReadCount !== 0">
            <span class="mesbadge badge badge-pill">
              {{ notReadCount }}
            </span>
            <span class="mesTitle"> 文字客服 </span>
          </div>

          <div class="unreadFrame" v-else>
            <span class="mesTitle"> 文字客服 </span>
          </div>
        </div>
      </div>
    </div> -->

    <div v-if="show">
      <div class="wrapper">
        <Nav v-if="!NoShowCompo"></Nav>
        <Menu v-if="NoMenuPage && !NoShowCompo"></Menu>
        <router-view></router-view>

        <!-- <div v-show="ShowRoom">
          <div class="Chatbox">
            <Chatroom />
          </div>
        </div> -->

        <Footer v-if="!NoShowCompo" class="sticky_bottom"></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/navContainer.vue";
import Footer from "@/components/footer.vue";
import Menu from "@/components/menuWrapper.vue";
import Chatroom from "@/components/Chatroom.vue";
import { mapGetters } from "vuex";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    Nav,
    Footer,
    Menu,
    Chatroom,
  },
  data() {
    return {
      // isLoading: true,
      show: false,
      access_token: "",
      NoMenuPage: false,
      NoShowCompo: false,
      ShowChatRoom: false,
    };
  },

  metaInfo: {
    htmlAttrs: {
      lang: "zh-tw",
    },

    meta: [
      {
        name: "description",
        content:
          "展昭國際企業群成立於1985年10月,是台灣第一家大型民間專業展覽公司,主要從事籌辦大型國際展覽會及會議,出版展覽專刊雜誌,光碟,代理世界各國知名展會徵展業務及建構網路數位線上展覽。",
      },
      {
        name: "keywords",
        content: "展昭展覽網,展昭,展覽,展覽行銷,展覽會,參展,世貿,南港展覽館",
      },
      {
        name: "apple-mobile-web-app-title",
        content: "展昭展覽網",
      },

      {
        name: "application-name",
        content: "展昭展覽網",
      },
    ],
  },

  computed: {
    ...mapGetters(["ShowRoom", "isLoading"]),
    ...mapState("chat", ["notReadCount"]),
  },

  methods: {
    openChatbox() {
      if (this.ShowRoom) {
        this.$bus.$emit("CloseConnet");
      } else {
        this.$bus.$emit("StartConnet");
      }
    },
  },

  created() {
    //驗證是否為登入狀態

    const vm = this;

    let nowPage = location.href;
    let activePage = nowPage.split("/")[4];

    if (!activePage) {
      vm.NoMenuPage = false;
      let getEmptyPage = nowPage.split("/")[3];
      if (getEmptyPage == "ExhibitorServiceTW") {
        vm.ShowChatRoom = true;
      } else {
        vm.ShowChatRoom = false;
      }
    } else {
      vm.NoMenuPage = true;
      let PageName = activePage.split("?")[0];
      // console.log(PageName)

      if (
        PageName == "upgradeGetCard" ||
        PageName == "upgradeGetList" ||
        PageName == "inviteVIPApply" ||
        PageName == "inviteVIPList" ||
        PageName == "invitePaperApply" ||
        PageName == "inviteProxyApply" ||
        PageName == "inviteProxyList" ||
        PageName == "inviteProxyRegApply" ||
        PageName == "inviteProxyRegList" ||
        PageName == "onlineExpoVideoList" ||
        PageName == "onlineExpoCardInfo" ||
        PageName == "onlineExpoBooth" ||
        PageName == "onlineExpoBanner4" ||
        PageName == "onlineExpoBanner3" ||
        PageName == "onlineExpoBanner2" ||
        PageName == "onlineExpoBanner1" ||
        PageName == "onlineVideoAdd" ||
        PageName == "upgradeGetCardInfo"
      ) {
        vm.NoShowCompo = true;
      } else {
        vm.NoShowCompo = false;
      }

      if (PageName == "SignalRCenter") {
        vm.NoMenuPage = false;
      } else {
        vm.NoMenuPage = true;
      }
    }

    const url = "https://www.chanchao.com.tw/apiLogin2/isAuthenticated";
    const info = null;

    vm.$http.post(url, info).then(function (response) {
      if (response.data == 200) {
        sessionStorage.setItem("access", "200");

        vm.$store.dispatch("updateLoading", false);

        vm.show = true;
      } else {
        sessionStorage.setItem("access", "");
        sessionStorage.removeItem("access");
        location.replace(
          "https://www.chanchao.com.tw/ExhibitorServiceTW/Landing"
        );
      }
    });
  },
};
</script>

<style lang="scss">
.floatChatIcon {
  position: fixed;
  bottom: 100px;
  right: 30px;
  width: 90px;
  height: 90px;
  // background: rgb(222 222 222 / 25%);
  border-radius: 50px;
  padding: 5px;
  z-index: 800;
  cursor: pointer;
  opacity: 0.8;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  border: 2px solid #ffbb80;
}

.floatChatIcon:after {
  content: "";
  display: block;
  position: absolute;
  top: -6px;
  left: -6px;
  right: -6px;
  bottom: -6px;
  background-color: #8484840f;
  border-radius: 99em;
}

.unreadFrame {
  position: relative;
}

.mesbadge {
  position: absolute;
  top: 24px;
  left: -3px;
  font-size: 13px;
  background-color: #ff2600;
  color: #fff;
}

.mesTitle {
  position: absolute;
  top: 11px;
  left: -56px;

  // background-color: #ff2600;
  font-size: 13px;
  color: #575555;
  width: 200px;
  font-weight: bold;
}

.Chatbox {
  position: fixed;
  bottom: 0px;
  right: 0px;
  width: 505px;
  // height: 800px;
  z-index: 4000;
}

@keyframes ldio-f9ujl5oazv5 {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ldio-f9ujl5oazv5 div {
  position: absolute;
  animation: ldio-f9ujl5oazv5 1s linear infinite;
  width: 160px;
  height: 160px;
  top: 20px;
  left: 20px;
  border-radius: 50%;
  box-shadow: 0 4px 0 0 #777b7c;
  transform-origin: 80px 82px;
}
.loadingio-spinner-eclipse-y24d302hfm {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
}
.ldio-f9ujl5oazv5 {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-f9ujl5oazv5 div {
  box-sizing: content-box;
}

.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.sticky_bottom {
  margin-top: auto;
}

.text-success {
  color: #217d9d !important;
}
</style>
